{
  "SET_NEW_PASSWORD": {
    "TITLE": "Yeni şifre oluştur",
    "PASSWORD": {
      "LABEL": "Parola",
      "PLACEHOLDER": "Parola",
      "ERROR": "Parola çok kısa."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Şifreyi onayla",
      "PLACEHOLDER": "Parolayı Onayla",
      "ERROR": "Parola eşleşmiyor."
    },
    "API": {
      "SUCCESS_MESSAGE": "Parola başarıyla değiştirildi.",
      "ERROR_MESSAGE": "Woot sunucusuna bağlanılamadı. Lütfen tekrar deneyin."
    },
    "CAPTCHA": {
      "ERROR": "Doğrulama süresi sona erdi. Lütfen captchayı tekrar çözünüz."
    },
    "SUBMIT": "Yolla"
  }
}
